import useInterval from "./utils/useInterval";
import {saveTriggerEvents} from "./api/trigger-event";
import {useContext} from "react";
import {ReducerStateInterface} from "./interfaces/core/ReducerStateInterface";
import {GlobalContext, ReducerActionType} from "./GlobalReducer";

export default function TriggerEventSync() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    useInterval(() => {
        console.log('Trigger Event Queue -> ', state.triggerEventQueue)
        if(state.triggerEventQueue.length){
            saveTriggerEvents(state.triggerEventQueue);
            dispatch({
                type: ReducerActionType.CLEAR_TRIGGER_EVENT_QUEUE
            });
        }
    }, 10000)

    return <></>
}